type apiParams = string | number;

export const __API = {
    register: {
        signin: 'account/auth/login/',
        forgetPassword: 'account/auth/forget_password/',
        getByCode: (code: apiParams) => `forms/kiosk_publish/get_by_code/${code}/`,
        getPortalByCode: (code: apiParams) => `forms/portal_publish/get_by_kiosk_code/${code}/`,
        questionerPublishes: 'account/user/get_questioner_publishes/',
    },
    workSpace: 'account/work_space/',
    dashboard: {
        profile: {
            index: 'account/user/my_profile/',
            avatar: 'account/avatar/',
            changePassword: 'account/user/change_password/',
            setFavForm: 'account/user/set_favorite_form/',
        },
    },
    upload: {
        // image: 'base/image_attachment/',
        // avatar: 'account/avatar/',
        file: 'base/file_attachment/',
        // video: 'base/video_attachment/',
        slp: (id: apiParams) => `base/file_attachment/slp_upload/${id}/`,
    },
    answers: {
        answer: 'answers/answer/',
        addAnswer: 'answers/answer/add/',
        closeAnswer: (token: string) => `answers/answer/close/${token}/`,
        answerItem: (token: string) => `answers/answer_item/add/${token}/`,
        answerDetail: (id: number) => `answers/answer/${id}/`,
        addView: `answers/answer/add_view/`,
        setLatLng: (token: string) => `answers/answer/add_lat_lng/${token}/`,
    },
    form: {
        detail: (id: number | string) => `forms/form/${id}/`,
        setFormNotif: (id: number) => `forms/form/${id}/set_me_to_answer_notify/`,
    },
    publish: {
        detail: (id: number) => `forms/publish/${id}/`,
        updateOnline: (code: number) => `forms/kiosk_publish/update_last_online/${code}/`,
    },
    notification: {
        devices: (id?: string) => `notifications/devices/${id ? id + '/' : ''}`,
        notifications: (id?: string) => `notifications/notifications/${id ? id + '/' : ''}`,
        markAll: 'notifications/notifications/mark_all_as_read/',
    },
    report: (formId: number) => `report/form/${formId}/answer_detail_report/`,
    version: (version_code: number) => `account/auth/version_control/${version_code}/`,
};
